import type { PostImplEditorRole } from '../../types/changes';

export const POST_IMPL_EDITOR_ROLE_OPTIONS: Array<{ value: PostImplEditorRole; label: string }> = [
  { value: 'admin', label: 'Administrador' },
  { value: 'gestor', label: 'Gestor de mudanças' },
  { value: 'dono', label: 'Dono da mudança' },
  { value: 'solicitante', label: 'Solicitante da mudança' },
];

export const DEFAULT_POST_IMPL_EDITOR_ROLES: PostImplEditorRole[] = [
  'admin',
  'gestor',
  'dono',
  'solicitante',
];

export function normalizePostImplEditorRoles(raw?: PostImplEditorRole[] | null): PostImplEditorRole[] {
  const allowed = new Set(POST_IMPL_EDITOR_ROLE_OPTIONS.map((item) => item.value));
  const cleaned = (raw || []).filter((item): item is PostImplEditorRole =>
    allowed.has(item as PostImplEditorRole),
  );
  return cleaned.length ? cleaned : [...DEFAULT_POST_IMPL_EDITOR_ROLES];
}
